/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState } from 'react';
import '../styles/bio.scss';
// import { Link } from 'react-router-dom';
import ProfilePic from '../media/profile_pic.png';
import Experience from './experience';
import ProjectGrid from './project-grid';
// eslint-disable-next-line no-unused-vars
import pdfResume from '../media/Full_Resume.pdf';

const EMAIL = 'schnei.nathan@gmail.com';

const Bio = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(EMAIL).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div>
      <div className="bio-container">

        <div className="pic-container">
          <div>
            <img src={ProfilePic} className="profile-pic" alt="Nathan Schneider" />
          </div>
          <div>
            <h1>Nathan Schneider</h1>
            <h3>Software Engineer</h3>
            <h3>
              <button type="button" className="copy-email" onClick={copyEmail} title="Copy email">
                {EMAIL} <i className={copied ? 'fa fa-check' : 'fa fa-clipboard'} />
              </button>
            </h3>
            <div className="logos">
              <a href="http://linkedin.com/in/nathan-schneider22/" target="_blank" rel="noreferrer">
                <i className="fa fa-linkedin-square" />
              </a>
              <a href={pdfResume} target="_blank" rel="noopener noreferrer">
                <svg className="resume-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="Resume">
                  <rect x="4" y="2" width="16" height="20" rx="2" />
                  <circle cx="12" cy="8" r="2.5" />
                  <path d="M8 14.5c0-2 1.8-3 4-3s4 1 4 3" />
                  <path d="M8 18h8" />
                </svg>
              </a>
            </div>

          </div>
        </div>
        <div className="blurb-container">
          <p>
            Hi, I&apos;m Nathan, a software engineer with AWS Bedrock Guardrails.
          </p>
          <p>
            I build LLM guardrails to protect against AI misuse and misbehavior, collaborating with researchers and scaling solutions to billions of tokens per minute.
          </p>

        </div>
      </div>
      <hr />
      <div className="question-button-section">
        <div>
          {/* <Link to="/questions/">
            <button type="button" className="question-button">Ask me a question</button>
          </Link> */}

        </div>
        {/* <h2>Q/A powered by <a label="GPT-3" href="https://openai.com/blog/gpt-3-apps/">Openai&apos;s GPT-3 </a> </h2> */}
      </div>
      <div className="main-columns">
        <Experience />
        <ProjectGrid />
      </div>
    </div>
  );
};

export default Bio;
